module.exports = __webpack_public_path__ + "img/img04_text_m.d750bada.png";